import { Button } from '@one-thd/sui-atomic-components';
import React, { memo } from 'react';
import { AddReceiptDrawer } from './add-receipt';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { pushEventInfo } from '../../../utils/analytics';
export var AddReceiptButton = memo(function (_a) {
    var svocId = _a.svocId, _b = _a.mobile, mobile = _b === void 0 ? false : _b;
    var _c = usePurchaseHistoryContext(), openAddReceiptDrawer = _c.openAddReceiptDrawer, setOpenAddReceiptDrawer = _c.setOpenAddReceiptDrawer;
    return (React.createElement("div", { "data-testid": "add-receipt-button" },
        mobile ? (React.createElement(Button, { variant: "secondary", onClick: function () {
                pushEventInfo({
                    category: { primaryCategory: 'overlay' },
                    eventInfo: { eventName: 'add receipt' },
                });
                setOpenAddReceiptDrawer(true);
            } }, "Add Receipt")) : (React.createElement(Button, { variant: "primary", onClick: function () {
                pushEventInfo({
                    category: { primaryCategory: 'overlay' },
                    eventInfo: { eventName: 'add receipt' },
                });
                setOpenAddReceiptDrawer(true);
            } }, "Add Receipt")),
        React.createElement(AddReceiptDrawer, { closeDrawer: function () { return setOpenAddReceiptDrawer(false); }, isDrawerOpen: openAddReceiptDrawer, svocId: svocId })));
});
